module.exports = __webpack_public_path__ + "img/resources-768.2d6edc33.jpg";